import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/services/utility.service';
import { fade, fadeOp } from 'src/app/util/animations.util';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    './reset-password.component.css'
  ],
  animations: [
    fadeOp,
    fade
  ]
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    private utility: UtilityService
  ) { }

  ngOnInit(): void {
  }

  changeLang(lang: string): void {
    this.utility.changeLang(lang);
  }
  get availableLangs(): string[] {
    return this.utility.getAvailableLang();
  }
  get currentLang(): string {
    return this.utility.getLang();
  }
}
